<template>
  <div
    align="center"
    class="circle"
    :class="{
      blue,
      independence,
      khaki,
      pink,
      geranium,
    }"
    :style="{
      height: size + 'px',
      width: size + 'px',
    }"
    @click="click"
  >
    <span
      class="text_circle"
      :style="{
        lineHeight: size + 'px',
      }"
    >
      <font-awesome-icon :icon="icon" />
    </span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'IconButton',
  components: {
    FontAwesomeIcon
  },
  props: {
    icon: Object,
    size: Number,
    blue: Boolean,
    independence: Boolean,
    khaki: Boolean,
    pink: Boolean,
    geranium: Boolean,
  },
  setup(_, { emit }) {
    const click = () => {
      emit('click');
    };

    return {
      click,
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

.circle {
  cursor: pointer;
  background: $blueNcs;
  border-radius: 50%;
  position: relative;
  vertical-align: middle;
  text-align: center;
  transition: all .2s ease-in-out;
}

.text_circle {
  margin-bottom: 50px;
}

.blue {
  background-color: $blueNcs;
  color: $white;
  border: 1px solid $white;

  &:hover {
    color: $blueNcs;
    background-color: $white;

    &::before {
      transform: translateY(0) rotate(0);
    }
  }
}

.independence {
  background-color: $independence;
  color: $white;
  border: 1px solid $independence;

  &:hover {
    color: $independence;
    background-color: $white;

    &::before {
      transform: translateY(0) rotate(0);
    }
  }
}

.khaki {
  background-color: $khaki;
  color: $white;
  border: 1px solid $white;

  &:hover {
    color: $white;
    background-color: $paradisePink;

    &::before {
      transform: translateY(0) rotate(0);
    }
  }
}

.pink {
  background-color: $paradisePink;
  color: $white;
  border: 1px solid $white;

  &:hover {
    color: $paradisePink;
    background-color: $white;

    &::before {
      transform: translateY(0) rotate(0);
    }
  }
}

.geranium {
  background-color: $geranium;
  color: $white;
  border: 1px solid $white;

  &:hover {
    color: $paradisePink;
    background-color: $white;

    &::before {
      transform: translateY(0) rotate(0);
    }
  }
}
</style>
